
import { defineComponent } from 'vue'

export default defineComponent({
    name: "ss-input",
    props: {
        icon: { type: String, default: undefined },
        type: { type: String, default: 'text' },
        value: { type: String, default: undefined },
        modelValue: { type: String, default: undefined },
        classIn: { type: String, default: undefined }
    },
    data() {
        return {}
    },
    methods: {
        getValue(element: EventTarget | null) {
            const inputEvent = element as HTMLInputElement
            return inputEvent.value
        }
    }
})
